const Form013EN = {
    stepName: {
        importantNotes: "Important Notes",
        proposedProjectDistrict: "District where the project is implemented",
        ngoParticular: "Particulars of Applicant NGO",
        ngoDeclaration: "Declaration of Applicant NGO",
        departmentParticular:
            "Particulars of Department/ Section/ Delegated Subsidiary Organisation Implementing the Project",
        coordinatorParticular:
            "Particulars of the Project Coordinator/Contact Person",
        schoolDeclaration: "Declaration of Collaborating School",
        proposedProject: "Information of Applied Project",
        noOfEligibleStudent:
            "Estimated no. of participating eligible students for activities to be organised in collaborating schools and/or centre(s)",
        activityDetail:
            "Details of the proposed activity(ies) under the project",
        projectIncomeAndExpend:
            "Estimated income and expenditure of the whole project",
        confirmation: "Confirmation",
        formA: "Upload Cooperation School/ Organization Form",
        formB: "Particulars of Department/ Section/ Delegated Subsidiary Organisation Implementing the Project",
        formExpired: "Important Notes",
    },
    header: {
        note: "Important Notes",
        partA: "Part A: District where the project is implemented(Each application form can only be used to apply for implementing the project in one district.  Applicants intending to implement the project in more than one district should submit a separate application.)",
        partB: "Part B: Particulars of Applicant NGO",
        partC: "Part C: Declaration of Applicant NGO",
        partD1: "Part D1: Particulars of <u>Department / Section</u> Implementing the project (For a project directly implemented by the applicant NGO, please fill in Part D1.)",
        partD2: "Part D2: Particulars of Delegated <u>Subsidiary</u> Organisation Implementing the Project (For a project implemented by the delegated subsidiary organisation.  Please fill in Part D2.)",
        partE: "Part E: Particulars of the Project Coordinator/Contact Person",
        partF: "Do your project involves collaboration with school(s)?",
        partF1: "Part F1: Declaration of Collaborating School",
        partF2: "Part F2: Declaration of Collaborating School",
        partG: "Part G: Information of Applied Project",
        partH: "Part H: Estimated no. of participating eligible students for activities to be organised in collaborating schools and/or centre(s)",
        partI: "Part I: Details of the proposed activity(ies) under the project",
        partJ: "Part J: Estimated income and expenditure of the whole project",
        partK: "Part K: Other relevant supplementary information(if any)",
    },
    label: {
        // Part A
        hkRegion: "HK Region",
        klRegion: "Kowloon Region",
        nteRegion: "New Territories East Region",
        ntwRegion: "New Territories West Region",
        // Part B
        english: "(English)",
        chinese: "(Chinese)",
        ngoName: "Name of NGO",
        ngoCode: "NGO Code",
        ngoHeadName: "Name of Head of NGO",
        ngoHeadTitle: "Title",
        ngoHeadPost: "Position(e.g. Chairperson/CEO/Supervisor)",
        ngoAddress: "Address of NGO",
        ngoTelNo: "Telephone no. of NGO",
        ngoEmail: "Email Address of NGO",
        ngoWebsite: "Website of NGO",
        ngoMission: "Mission and objectives of NGO",
        majorArea: "Major areas of services of NGO",
        incomeSource: "Sources of income of NGO",
        experienceDesc:
            "Please state briefly the experience in providing services to students:",
        cbpExperience:
            "Past experience in organising Community-based Projects (if any):",
        otherExperience:
            "NGO’s experience in organising after-school activities in the past 5 years:(e.g. collaboration in School-based Grant activities or other projects)",
        schoolYear: "School Year",
        projectCode: "Project Code",
        collaboratingSchoolName: "Name(s) of Collaborating School(s)",
        // Part C
        c1: "On behalf of (Name of applicant NGO) <u>&emsp;{{name}}&emsp;</u>, I hereby declare that",
        c1a: "Our NGO is an approved charitable NGO or trust of a public nature under Section 88 of the Inland Revenue Ordinance (Cap.112) and our work is mainly in social welfare related services.",
        // c1bi1: "The proposed project in this application form will be <b><u>directly</u></b> implemented by our Organisation. Information of the Department/Section implementing the Project is provided in Part D1. Particulars of the Project Coordinator are provided in Part E.",
        c1bi1: "Name of Department/Section Implementing the Project:",
        // c1bi2: "Name of Department/Section implementing the Project: ",
        c1bi2: "If the applied project is approved with funding support, it will be <b><u>directly</u></b> implemented by our NGO. Information of the Department/Section Implementing the Project is provided in Part D1.  Particulars of the Project Coordinator are provided in Part E.",
        c1bii1: "If the applied project is approved with funding support, our NGO will delegate our <b>subsidiary organisation</b> (name of subsidiary organisation) ",
        c1bii2: " to implement the proposed project stated in this application form.  I understand that although our subsidiary organisation is fully delegated  to implement the said project, our NGO is ultimately responsible for it under Clause 9.4 of the School-based After-school Learning and Support Programmes Grantee Agreement.  Particulars of our delegated subsidiary organisation are provided in Part D2 and particulars of its Project Coordinator are provided in Part E.",
        c1bii3: "<b>[Relevant certification of (b)(i) and/or (ii) is/are enclosed.]</b>",
        c1biii: "The applied project does not duplicate our other project(s) implemented for the community/school(s) and funded by other organisations.",
        c1c: "The applied project does not duplicate our other project(s) implemented for the community/school(s) and funded by other organisations.",
        c1d: "I certify that all the information given in this application form is true and accurate.  I understand that if I wilfully give any false information or withhold any material information, the application will immediately become void, any grant approved will then be withheld, any payment made must be refunded to the Education Bureau and the ultimate responsibility arisen shall be borne by the NGO I represent.",
        c1e: "I consent that the information provided in this application form may be used by the Education Bureau to process the application and conduct research, evaluative studies and training/sharing session.",
        c1f: "If the applied project is approved with funding support, I pledge to participate actively in all the promotion, dissemination and publicity activities relevant to the project.",
        c1g: "I understand that the Education Bureau reserves the right to require our NGO to provide proof of our relationship with our delegated subsidiary organisation.",
        post: "Position of Head of NGO",
        ngoChop: "NGO's Chop",
        sectionName: "Name of Department/Section",
        subsidiaryOrganisation: "Subsidiary Organisation",
        // Part D
        partD1: "Department/Section",
        partD2: "Subsidiary Organisation",
        departmentName: "Name of {{name}}",
        departmentHeadName: "Name and position of Head of {{name}}",
        departmentHeadTitle: "Title",
        departmentHeadPost: "Position",
        departmentAddress: "Address of {{name}}",
        departmentTelNo: "Telephone no. of {{name}}",
        departmentFaxNo: "Fax no. of {{name}}",
        departmentEmail: "Email Address of {{name}}",
        departmentWebsite: "Website of {{name}}",
        departmentChop: "Chop of NGO's {{name}}",
        // Part E
        partD1Choice:
            "According to Clause 9.1 of the School-based After-school Learning and Support Programmes Grantee Agreement, our NGO implementing the project has appointed the following person to be the Project Coordinator:",
        partD2Choice:
            "According to Clause 9.1 of the School-based After-school Learning and Support Programmes Grantee Agreement, delegated subsidiary organisation implementing the project has appointed the following person to be the Project Coordinator:",
        orgName: "Name of {{name}} implementing the project:",
        partD1OrgName:
            "Name of <u><b>Department / Section</b></u> Implementing the Project：",
        partD2OrgName:
            "Name of Delegated <b><u>Subsidiary</u></b> Organisation Implementing the Project：",
        coordinatorPost: "Position of Project Coordinator",
        coordinatorName: "Name of Project Coordinator",
        coordinatorTitle: "Title",
        coordinatorContact: "Contact of Project Coordinator:",
        coordinatorTelNo: "NGO Telephone no.",
        coordinatorMobile: "Emergency Phone no.",
        coordinatorFaxNo: "Fax no.",
        coordinatorEmail: "Email Address",
        contactPersonName:
            "Name of Contact Person (other than the Project Coordinator)",
        contactPersonTitle: "Title",
        contactPersonPost: "Position of Contact Person",
        contactPersonContact: "Contact of Contact Person:",
        contactPersonTelNo: "NGO Telephone no.",
        contactPersonMobile: "Emergency Phone no.",
        contactPersonEmail: "Email Address",
        note: "Note:",
        noteE1: "The ceiling of the total grants under the care of a Project Coordinator, irrespective of the number of project(s), should not exceed HK${{budgetLimitEn}}.",
        noteE2: "The Project Coordinator is fully responsible for the overall management of the approved project on behalf of the applicant NGO or delegated subsidiary organisation implementing the project.  The NGO should ensure that the information of Project Coordinator and the Contact Person is accurate so that the Education Bureau could contact the relevant personal in a timely manner.",
        ngoSchool: "Collaborating School List",
        ngoSchoolSame:
            "Did your school collaborate with the same NGO in {{lastYear}} s.y.?",
        ngoSchoolName: "Name of School",

        // Part F
        partF1Note:
            "This part applies to an application for which the school continues to collaborate with the same NGO in 2021/22 s.y. (If the school did not collaborate with the NGO in 2020/21 s.y., please complete Part F2.) There is no restriction on the number of collaborating schools but they must be located in the same district.",
        partF2Note:
            "This part applies to an application for which the school did not collaborate with the NGO on CBP in 2020/21 s.y. (If the school continues to collaborate with the same NGO as in 2020/21 s.y., please complete Part F1.) There is no restriction on the number of collaborating schools but they must be located in the same district",
        f1: "To be completed by the collaborating school:",
        f2: "To be completed by the applicant {{name}}:",
        f21: "Mutual agreement on administrative procedures has been reached between our school and the applicant NGO. School teacher in-charge and the project coordinator have signed for verification.",
        f22: "Mutual agreement on administrative procedures has been reached between our organisation and the collaborating school. School teacher in-charge and the project coordinator have signed for verification.",
        f3: "Meeting minutes between school and the applicant NGO:<br/>(To be co mpleted together by school and the applicant NGO after mutual agreement on the details of the project has been reached between school and the NGO.)",
        f31: '(Please fill in the contents and put a "✓" in the appropriate box(es))',
        f3a: "Both parties have discussed the detailed terms/conditions of the project by way of the following and mutual agreement has been reached.</br>(For details, please refer to Part I of this application form.)",
        f3b1: "The NGO should submit the document(s) below to school at least ",
        f3b2: " working day(s) before the commencement of activities for reference.",
        f3c: "The NGO should ensure that all instructors(including substitute instructors) appointed to school have undergone the Sexual Conviction Record Check.",
        f3d1: "The school should notify the NGO at least ",
        f3d2: " working days before the commencement of activities if there is any adjustment on the details/content of the approved activities; the NGO should submit the application for project adjustment to the Education Bureau within ",
        f3d3: " working days after receiving request from school.",
        f3e1: "The NGO should reply to school's queries concerning the content or progress of Community-based Projects within ",
        f3e2: " working days. Written reply with relevant document(s) should be submitted when required.",
        f3f1: "The NGO should notify the school of the change of Project Coordinator by phone or through written notification within ",
        f3f2: " working days.",
        f3g: "Both parties should follow the arrangement(s) below for change of instructor(s):",
        f3g1: "Notify the other party immediately. The NGO should arrange new instructor(s) within ",
        f3g2: " working days and submit relevant documents as listed in (b) to school for checking and retention.",
        f3h: "The NGO should follow the procedure(s) below for the arrangement of substitute instructors:",
        f3h1: "The NGO should notify the school of the arrangement of substitute instructors at least ",
        f3h2: " hours before the commencement of activity. Relevant documents as listed in (b) should be submitted to school within ",
        f3h3: " working days for checking and retention.",
        schoolName: "Name of School",
        schoolAddress: "Address of School",
        schoolCode: "School Code",
        session: "Session",
        schoolType: "School Type",
        schoolLevel: "School Level",
        numOfStudent: "No. of Eligible Students",
        numOfStudent1: "Estimated no. of <u>eligible students</u>",
        numOfStudent2:
            "referred by school to <u>participatein</u> the project(count by heads)",
        numOfStudent3: " (including ",
        numOfStudent4: " non-Chinese speaking(NCS) students, ",
        numOfStudent5: " special educational need(SEN) students, and ",
        numOfStudent6: " newly arrived children(NAC)).",
        numOfNCS: "No. of Non-Chinese Speaking(NCS) Students",
        numOfSEN: "No. of Special Educational Need(SEN) Students",
        numOfNAC: "No. of Newly Arrived Children",
        teacherName: "Name of School teacher-in-charge",
        teacherPost: "Position",
        schoolHead: "School Supervisor/Principal",
        schoolHeadName: "Name of {{name}}",
        schoolTel: "School Tel. no.",
        schoolFax: "School Fax. no.",
        schoolEmail: "Email Address",
        schoolChop: "School Chop",
        partD1Ngo: "NGO",
        partD2Ngo: "NGO's Subsidiary Organisation",
        ngo: "NGO/Subsidiary Organisation",
        organisationName: "Name of {{name}}",
        organisationChop: "Chop of {{name}}",
        wayToDiscuss: "Way to Discuss",
        otherDocument: "Other document(s)",
        otherArrangement: "Other arrangement(s)",
        workingDay: "Working Day(s)",
        workingHour: "Hour(s)",
        other: "Others",
        // Part G
        projectTitle: "Project Title",
        commencementDate: "Date of Commencement",
        completionDate: "Date of Completion",
        projectObjective: "Project Objective(s)",
        evaluationMethod: "Methods of Evaluation",
        g4a: "Estimated total no. of eligible students of <u>collaborating school(s)</u>(count by heads):",
        g4a1: "( ",
        g4a2: " students)",
        g4b: "Estimated total no. of eligible students in the community served project(s) (count by heads):",
        g4b1: "( ",
        g4b2: " Primary Students + ",
        g4b3: " Secondary Students = <u>&emsp;{{num}}&emsp;</u> students<sup>#</sup>)",
        g4b4: "#Including the following students:",
        g4ab: "Total = <u>&emsp;{{num}}&emsp;</u> students",
        NCS: "(i) Non-Chinese Speaking (NCS) Students:",
        SEN: "(ii) Students with Special Educational Needs:",
        NAC: "(iii) Newly-arrived Children (NAC):",
        primary: "Primary",
        secondary: "Secondary",
        total: "Total(man-head)",
        // Part H
        totalByActivity:
            "Estimated no. of participating eligible students in each activity",
        totalBySchool:
            "Total(i.e. aggregate number of participating students in the above activities)",
        // Part I
        priority: "Order of priority",
        edbPriority: "Order of priority(For internal use)",
        activityNature: "Nature of Activity",
        activityName: "Name of Activity",
        activitySchool: "Name of Collaborating School(if applicable)",
        activityContent: "Briefly describe the objectives and contents",
        objectiveContent: "objectives and contents",
        activityType: "Activity Type",
        i5a1: "Estimated no. of eligible students served(count by heads)<sup>#</sup>: ",
        i5a2: ", including ",
        i5a3: " non-Chinese speaking(NCS) students, ",
        i5a4: " special educational need(SEN) students and ",
        i5a5: " newly-arrived children(NAC).",
        i5b1: "#For activity serving the community without collaborating school(refer to pt. 3) or special schools, please indicate the estimation separately:",
        i5b2: " primary students(including ",
        i5b3: " NCS students, ",
        i5b4: " SEN students and ",
        i5b5: " NAC) and/or ",
        i5b6: " secondary students(including ",
        i5b7: " NAC).",
        i61: "Estimated no. of fee-charging non-eligible students",
        i62: "(count by heads): ",
        i63: " students(if applicable)",
        i101: "Total no. of sessions per year",
        i102: " sessions x ",
        i9: "Activities per group:",
        i10: "Breakdown of expenditure items",
        i11: "Total expenditure(A)",
        i12: "Breakdown of income",
        i13: "Total income(B)",
        i14: "Grant applied(A - B)",
        date: "Date(s):",
        from: "From",
        to: "To",
        time: "Time",
        timeNote: '(Tick "✓" the appropriate time slot)',
        numOfGroup: "No. of group(s)",
        studentRatio: ", Instructor-student ratio per group",
        ratio: "Instructor-student ratio",
        classVenue: "Venue",
        numOfSession: "",
        numOfHour: "",
        halfDay: "Half-day",
        wholeDay: "Whole day",
        venue: "Venue",
        district: "District",
        budget: "Breakdown of the budget for the proposed activity:",
        instructor: "Instructors' ",
        assistant: "Teaching Assistants'",
        remuneration: "remuneration: ",
        academic: "Proposed academic qualifications of instructors",
        reason: "State their status and reasons for the employment",
        stateReason: "status and reasons for the employment",
        socialWorker: "Social worker:",
        otherStaff: "Other staff:",
        material: "Material expenses:",
        specify: "Please specify",
        campFee: "Camp/Admission fee: ",
        mealFee: "Student meal:",
        trafficFee: "Activity transportation fee:",
        numOfMinibus: "No. of minibus",
        numOfCoach: "No. of coach",
        volunteerAllowance: "Volunteers allowance:",
        numOfVolunteer: "No. of volunteers",
        totalAttendance: "Total no. of attendance",
        nonEligibleFee: "Charge on Non-eligible students",
        name: "Name",
        confirmedBy: "Confirmed by Collaborating School:",
        // Part J
        projectExpend: "Estimated expenditure of the proposed activites(A):",
        administrationCost: "Estimated administration cost(B)",
        coordinationCost: "Estimated project coordination cost(C)",
        projectIncome: "Total estimated income(D):",
        totalAmount: "Total amount of grant applied(A+B+C-D):",
        // Part K
        otherInformation: "Other relevant supplementary information",
        partKAtt1:
            "NGO participated in the CBP in previous years: documents certifying that the applicant NGO and its delegated Subsidiary Organisation are approved charitable institutions or trusts of a public character under Section 88 of the Inland Revenue Ordinance (Cap.112).",
        partK2: "The applicant NGO making application for the first time or NGO with memorandum of association, constitution or charter amended: documents certifying that the applicant NGO is an approved charitable institution or trust of a public character under Section 88 of the Inland Revenue Ordinance (Cap.112) and the applicant’s memorandum of association in case it is a limited company under the Companies Ordinance (Cap.32) or constitution or charter in case it is registered under the Societies Ordinance (Cap. 151).",
        partKAtt2:
            "A copy of Certificate of Registration of a School or the completed application form for getting Exemption from Registration as a School under Section 9(5) of the Education Ordinance (Cap. 279) for offering non-formal curriculum in places other than the collaborating school premises.",

        num: "Number",
        int: "Integer",
        colon: ':<span class="danger">*</span>',
        statement:
            "I have read, understood and agreed to the above terms and conditions",
        note1: "All information of the e-Form contained herein shall be subject to the application form on the EDB website",
        note10: "https://www.edb.gov.hk/en/student-parents/support-subsidies/after-sch-learning-support-program/community-based-projects/index.html",
        note2: "Points to note:",
        note20: "Please read thoroughly the Guideline for Community-based Projects under the School-based After-School Learning and Support Programmes before completing this application form.",
        note21: "The Community-based Projects (projects)  are open for application of non-profit-making non-governmental organisations (NGO) only.",
        note22: "The applicant NGO (including its delegated subsidiary organisation implementing the project) must be an approved charitable institution or trust of a public character under Section 88 of the Inland Revenue Ordinance (Cap.112) with social welfare related services as one of the objectives for which it is established in its memorandum of association, constitution or charter. To simplify the application process, unless the memorandum of association, constitution or charter have been amended, an NGO which had project (s) approved before only needs to submit the documents certifying that the applicant NGO (including its delegated subsidiary organisation implementing the project) is an approved charitable institution or trust of a public character under Section 88 of the Inland Revenue Ordinance (Cap.112). The Education Bureau may request the applicant NGO to provide further documents, if necessary. For the applicant NGO making application for the first time, one copy each of the aforementioned documents should also be attached to the application form.",
        note23: "Notwithstanding anything to the contrary in the application form, the Education Bureau reserves the right to disqualify an applicant NGO on the grounds that the applicant NGO has engaged, is engaging, or is reasonably believed to have engaged or be engaging in acts or activities that are likely to cause or constitute the occurrence of offences endangering national security or otherwise the exclusion of the applicant NGO is necessary in the interest of national security, or is necessary to protect the public interest of Hong Kong, public morals, public order or public safety.",
        note24: "Please use the application form for the {{schoolYear}} school year, otherwise the application will not be entertained.  Do not change the format of this application form.  However, the applicant NGO is welcome to add relevant information in the form of attachment.",
        note25: "The applied project could complement but should not replace or overlap with project(s) funded by other organisations (such as Life-wide Learning Grant, the Home Affairs Department’s funding and the Social Welfare Department’s Support Scheme, etc).",
        note26: "The project should only support eligible students [i.e. P1 to S6 students in receipt of the Comprehensive Social Security Assistance (CSSA) or full-grant assistance under the Student Financial Assistance Schemes]. For project(s) implemented in collaboration with school(s), the student beneficiaries should also include those categorised as needy students by the school using the discretionary quota.",
        note27: "For project(s) involving collaboration with school(s), the applicant NGO and collaborating school(s) are required to complete the Information of Collaborating School(s) in Part F1 or Part F2 of the PDF form downloaded from the e-Form system. If the applicant NGO collaborated with the collaborating school(s) to implement the project in the {{lastYear}} school year and will continue their collaboration in the {{schoolYear}} school year, please complete Part F1. If the applicant NGO and the collaborating school(s) start to collaborate to implement the project in the {{schoolYear}} school year, please complete Part F2 to prove that the applicant NGO and the collaborating school(s) have good and adequate communication to ensure the two parties have reached a mutual agreement on the details of the project (e.g. the collaborating school’s needs, activity arrangements and the instructors’ requirements, including the adoption of the Sexual Conviction Record Check, etc.) in order to facilitate the smooth implementation of the project subsequently. In addition, collaborating school(s) should also sign and stamp to confirm details of the proposed activities under the project in Part I of the PDF form. After submitting the e-Form, the applicant NGO should submit the original copy of the completed Parts F and I of the application form to the Student Special Support Section of the Education Bureau before the application deadline (Address: Student Special Support Section, Room 1141, 11/F, Wu Chung House, 213 Queen’s Road East, Wan Chai, HK) by post or by hand on or before the aforementioned deadline. If the above forms are to be submitted by post, please send by registered mail to ensure successful delivery. For application submitted by post, the stamped date will be taken as the date of application. <b>Submission by fax or email will NOT be accepted</b>. All submitted documents are non-returnable.",
        note28: "If non-formal curriculum (e.g. tutorial service, learning skills training or language training) is offered in places other than the collaborating school premises, or the non-formal curriculum offered in a collaborating school premises includes other collaborating schools’ students, the applicant NGO must comply with the requirements stipulated in the Education Ordinance. Please attach relevant documents (such as a Certificate of Registration of a School or application for Exemption from Registration as a School under Section 9(5) of the Education Ordinance (Cap. 279)) in submitting the application.",
        note29: "Application for the project commences on 25 February {{startYear}}.  The application deadline is <b><u>28 March {{startYear}}</u></b>. Late applications are generally not accepted, but the Committee on School-based After-school Learning and Support Programmes (the Committee) will consider late applications fulfilling the following criteria on case-by-case basis: <ul><li>The project must be implemented by an NGO in collaboration with school(s); and</li><li>The NGO must submit the application no later than 15 working days from the application deadline and provide a written justification for the late submission, along with relevant supporting document(s) from the collaborating school(s).</li></ul>Regarding the handling of late applications mentioned above, the Committee will also consider the NGO's past submission records.",
        note210:
            "The ceiling of the total amount of grant applied for each project is capped at HK${{budgetLimitEn}}.  In tandem, the ceiling of the total grants under the care of a Project Coordinator, irrespective of the number of project(s), should also not exceed HK${{budgetLimitEn}}.",
        note211:
            "Details of the approved grant and activity(ies) under the project will be provided to relevant collaborating school(s) for reference.",
        note3: "Personal Information Collection Statement",
        note30a: "Purposes of Collection",
        note30: "The personal data provided in this application will be used by the Education Bureau for the purpose of assessing applications to the Programme. For successful applications, such data will also be used for the Programme monitoring, promotion, publicity and dissemination purposes as appropriate.",
        note31: "The provision of personal data by means of this application form is voluntary. Failure to provide these data may affect the processing and outcome of your application.",
        note32a: "Classes of Transferees",
        note32: "Personal data provided in this application may be disclosed by the Education Bureau, if necessary, to the Committee on the Programme, other Government Departments, external reviewers, monitoring members of the Programme and other people concerned.",
        note33: "Applicants have the right to request access to and correction of your personal data as provided for in Sections 18 and 22 and Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance. Your right of access includes the right to obtain a copy of your personal data provided in this application form.",
        note34a: "Enquiries",
        note34: "Enquiries concerning the personal data collected by means of this application form, including making of access and corrections, should be addressed to:",
        note40Txt: "Address:",
        note40Val:
            "Student Special Support Section,<br/>Education Bureau,<br/>Room 1141, 11/F, Wu Chung House,<br/>213 Queen’s Road East, Wan Chai, HK.",
        note41Txt: "Tel. No.:",
        note41Val: "2892 6659",
        note42Txt: "Fax. No.:",
        note42Val: "3107 1306",
        editNote: "Notes:",
        editNoteContent:
            "If applicant/ approver need to edit the e-form content shown in preview PDF, please return the form to applicant to edit.",
        nameOfSO: "name of subsidiary organisation",
        nameOfHSO: "name of head of subsidiary organisation",
        addressOfSO: "Address of subsidiary organisation",
    },
    tooltip: {
        ngoCode:
            "Only applicable to NGOs participated in the project in {{lastYear}}",
        schoolType:
            "Separate forms should be used for secondary and primary section of special schools",
        numOfStudent:
            "School is suggested to make reference to the actual no. of students participating in the 2020/21 Communitybased Projects for estimation.",
        eligibleStudent:
            "Eligible Students i.e. P1 to S6 students in receipt of the Comprehensive Social Security Assistance, full-grant assistance under the Student Financial Assistance Schemes and the disadvantaged students provided by the schools under their discretionary quota.",
        coordinatorName:
            "Personnel stated in this part must be the Project Coordinator stated in Part E.",
        completionDate:
            "The project should be completed on or before 31 July {{endYear}}",
        activitySchool:
            "One form for one collaborating school/centre only. Please photocopy this page if you wish to apply for more than one collaborating school/centre.",
        activityType: {
            b1: "one only, e.g. music, handicraft. Please specify no. of session for each group if they are not the same.",
            b3: "one only, e.g. ball games, swimming. Please specify no. of session for each group if they are not the same.",
        },
        numOfNonEligibleStudent:
            "Non-eligible students - students who have to pay fee to join an activity. These students must pay full fee.",
        time: "Tutorial service under the project should be no longer than 4.5 hours per week to allow students to participate in other after-school activities.",
        numOfGroup:
            "The number. of groups equals the number of instructors to be employed",
        venue: "If non-formal curriculum(e.g. tutorial service, learning skills training and language training) is offered in places other than the collaborating school premises, or the non-formal curriculum offered in a collaborating school premises includes other collaborating schools' students, the applicant NGO must comply with the requirements stipulated in the Education Ordinance. Please attach relevant documents(such as Certificate of Registration of a School or application for Exemption from Registration as a School) in submitting the application.",
        halfDay: "at least 4 hrs",
        wholeDay: "at least 7 hrs",
        cost: "For administration cost, please fill in Part J(2).",
        item: "If the enrolled students are less than the approved number, NGO should reduce the number of groups and all expenses on a pro-rata basis.",
        instructor:
            "Qualification of instructors are specified in Guideline for Community-based Projects found in our Community-based Projects web-page.",
        assistant:
            "Teaching Assistant is responsible for assisting the implementation of activity throughout the year.",
        mealFee: "Only for whole-day outdoor activities",
        trafficFee: "Only for outdoor activities or camping",
        projectExpend: "Total expenses of all Part I activities",
        administrationCost:
            "The applied amount of estimated administration cost must be an integer",
        projectIncome: "Total incomes of all Part I activities",
        coordinationCost:
            "The applied amount of estimated project coordination cost must be an integer",
        totalAmount:
            "The ceiling of the total amount of grant applied for each project is capped at HK${{budgetLimitEn}}.",
    },
    unit: {
        s: "session(s)",
        hps: "hrs per session",
        t: "times",
        d: "times",
        h: "(/hr)",
        $: "$",
        "h/s": "hrs/(session)",
        ss: "sessions",
        g: "groups",
        ps: "",
        pg: "",
        p: "persons",
        stu: "Students",
    },
    doc: {
        1: "List of instructors",
        2: "Instructors' academic qualification",
        3: "Instructors' reference number for the Sexual Conviction Record Check",
        4: "Contract(s) between the NGO and instructor(s)",
        5: "Others: ",
    },
    districtObj: {
        hkRegion: {
            cw: "Central & Western",
            hke: "Hong Kong East",
            is: "Islands",
            so: "Southern",
            wc: "Wan Chai",
        },
        klRegion: {
            klc: "Kowloon City",
            kt: "Kwun Tong",
            sk: "Sai Kung",
            ssp: "Sham Shui Po",
            wts: "Wong Tai Sin",
            ytm: "Yau Tsim & Mong Kok",
        },
        nteRegion: {
            no: "North",
            st: "Sha Tin",
            tp: "Tai Po",
        },
        ntwRegion: {
            kc: "Kwai Chung & Tsing Yi",
            tw: "Tsuen Wan",
            tm: "Tuen Mun",
            yl: "Yuen Long",
        },
    },
    titleObj: {
        mr: "Mr.",
        mrs: "Mrs.",
        miss: "Miss.",
        ms: "Ms.",
    },
    sessionObj: {
        am: "AM",
        pm: "PM",
        wd: "WD",
    },
    schoolTypeObj: {
        govt: "Govt",
        aided: "Aided",
        caput: "Caput",
        dss: "DSS",
        private: "Private",
        special: "Special",
    },
    schoolLevelObj: {
        sec: "Sec",
        pri: "Pri",
    },
    schoolHeadObj: {
        supervisor: "School Supervisor",
        principal: "School Principal",
    },
    wayToDiscussObj: {
        interview: "Interview",
        phone: "Phone conversation",
        email: "Email",
        fax: "Fax",
        other: "Others:",
    },
    activityObj: {
        a1: "A1: Tutorial Service",
        a2: "A2: Learning Skills Training",
        a3: "A3: Language Training",
        b1: "B1: Art & Cultural Activities",
        b2: "B2: Visits/Outdoor Activities",
        b3: "B3: Sports Activities",
        c1: "C1: Voluntary Service",
        c2: "C2: Development of Self-confidence",
        c3: "C3: Social/Communication Skills Training",
        c4: "C4: Adventure Activities",
        c5: "C5: Leadership Training",
    },
    collaborateObj: {
        single: "Activity for one collaborating school only",
        alone: "Activity for the community without collaborating school",
    },
    timeObj: {
        afterSchool: "Mon - Fri after school - 6pm",
        saturday: "Sat ",
        after6pm: "Mon - Fri after 6pm",
        holiday: "Holiday ",
    },
    ampmObj: {
        am: "AM",
        pm: "PM",
    },
    academicObj: {
        secondary5:
            "Completion of Secondary 5(Grade E or above in 5 subjects including Chinese, English (Syl. B), and Mathematics in HKCEE) or Completion of Secondary 6 (Level 2 in 5 subjects including Chinese, English, and Mathematics in HKDSE)",
        secondary6:
            "Completion of Secondary 6(Level 3 in 5 subjects including Chinese, English, and Mathematics in HKDSE) or Completion of Secondary 7 (Grade E or above Chinese, English and 2 AL subjects in HKALE)",
        secondaryGrad:
            "Post-secondary college graduates(Higher diploma/ Associate degree)",
        uGrad: "University graduates",
        chiMajorGrad: "University graduates(major in Chinese)",
        engMajorGrad: "University graduates (major in English)",
        mathMajorGrad: "University graduates (major in Mathematics)",
    },
    postObj: {
        principal: "School Principal",
        teacher: " Teacher-in-charge",
    },
    errorMsg: {
        totalErr: "The total number of student should not more than 5000.",
        fromDateErr: "This date should before the completion date",
        toDateErr: "This date should after the starting date",
    },
    FormA: {
        title: "Part F: Declaration of Collaboration School",
        schoolName: "School Name",
        uploadFile: "Upload File",
        scrn: "SCRN",
        formType: "Form Type",
        type: "Part {{formType}}: Declaration of Collaborating School",
        typeF1: "(for school in collaboration with the same NGO on CBP in {{lastYear}} s.y.)",
        typeF2: "(for school not in collaboration with an applicant NGO on CBP in {{lastYear}} s.y.)",

        // added for new workflow
        partD: "Part D: Particulars of Subsidiary Organisation implementing the Project",
        subsidiaryOrganisation: "Subsidiary Organisation",
        orgId: "Organisation id",
        uploadedForm: "Uploaded Form",
        partD2: "Part D2: Particulars of Subsidiary Organisation implementing the Project",
        uploadInstruction:
            "please upload the completed form with the above mentioned parts that should be filled by relative cooperating school(s) and subsidiary organisation.",
    },
};

export default Form013EN;
